/* @flow */

import WebshopCenteredContentSettings from './WebshopCenteredContentSettings'
import WebshopCenteredContent from './WebshopCenteredContent'

const widget = {
  component: WebshopCenteredContent,
  settings: WebshopCenteredContentSettings,

  available_children: [
    'announcement_bar',
    'banner',
    'header',
    'header_backdrop',
    'grid',
    'link_button',
    'product_carousel',
    'text',
  ],
  label: 'Centered content w/ limited width',

  default_settings: {},
  default_style: {},
}

export default widget
